import React, { useEffect } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import { Image } from "@wss/image";
import Icon from "~/common/Icons/Standard/index";
import { MediaReview } from "./reviewModels";
interface Props {
  mediaReview: MediaReview;
  setSelectedModalMedia: () => void;
  iconClassName?: string;
  thumbnailClasses?: string;
  containerClasses?: string;
  productReviewIndex: number;
  isProductReviewPage?: boolean;
  totalRemainingMediaReviews?: number;
  truncate?: boolean;
  isModalTrigger?: boolean;
}
interface ThumbnailContentProps {
  isVideo: boolean;
  thumbnailClasses?: string;
  mediaReview: MediaReview;
  iconClassName?: string;
}
const ThumbnailContent = ({
  isVideo,
  thumbnailClasses,
  mediaReview,
  iconClassName
}: ThumbnailContentProps) => {
  return <div className={`${thumbnailClasses} flex pb-0 aspect-square h-auto relative overflow-hidden`} id={mediaReview.id.toString()} data-sentry-component="ThumbnailContent" data-sentry-source-file="MediaReviewThumbnail.tsx">
      <Image alt={mediaReview.caption} className="absolute z-10 w-full h-full block opacity-100 object-cover" height={1} loading="lazy" src={mediaReview.thumbnail} width={1} data-sentry-element="Image" data-sentry-source-file="MediaReviewThumbnail.tsx" />
      {isVideo ? <>
          <div className={`absolute z-20 w-full h-full ${isVideo && "bg-gray-800/45 mix-blend-multiply"}`} />
          <div className="isolate absolute z-30 w-full h-full flex justify-center items-center">
            <Icon className={iconClassName} height="2rem" width="2rem" name="play" />
          </div>
        </> : null}
    </div>;
};
const MediaReviewThumbnail = ({
  mediaReview,
  setSelectedModalMedia,
  iconClassName = "",
  thumbnailClasses = "",
  containerClasses = "",
  productReviewIndex,
  isModalTrigger = true,
  isProductReviewPage = true,
  totalRemainingMediaReviews = 0,
  truncate = false
}: Props) => {
  const isVideo = mediaReview.type === 1;
  const useOverlay = isVideo || truncate && !isProductReviewPage && totalRemainingMediaReviews > 0;
  useEffect(() => {
    const triggerId = document.getElementById(mediaReview.id.toString());
    if (triggerId) {
      triggerId.addEventListener("click", () => {
        setSelectedModalMedia();
      });
    }
  }, [mediaReview.id, setSelectedModalMedia]);
  return <>
      {isModalTrigger ? <Modal.Trigger theme="headless" htmlFor="zest-modal-button" className={`${containerClasses} thumbs__item bg-transparent p-1 border border-solid border-gray-300 hover:border-gray-500 hover:border-2 hover:p-[3px] active:border-gray-700 active:border-2 active:p-[3px] rounded shadow-none`} data-testid={`${isVideo ? "video" : "photo"}-review-thumbnail`} onClick={setSelectedModalMedia} type="button" aria-label={`${isVideo ? "view video" : "view image"} ${productReviewIndex + 1}`} CustomTrigger={<div className={`${thumbnailClasses} thumbs__image flex pb-0 aspect-square h-auto relative overflow-hidden`} id={mediaReview.id.toString()}>
              <Image width={1} height={1} className="absolute z-10 w-full h-full block opacity-100 object-cover" loading="lazy" src={mediaReview.thumbnail} alt="" />
              {truncate && totalRemainingMediaReviews > 0 && <>
                  <div className="absolute z-20 w-full h-full bg-gray-800 opacity-45 mix-blend-multiply" />
                  <div className={`isolate absolute z-30 w-full h-full text-white text-lg ${totalRemainingMediaReviews.toString().length > 2 ? "lt:text-sm xl:text-lg" : ""} font-bold flex justify-center items-center`}>
                    +{totalRemainingMediaReviews}
                  </div>
                </>}
              {!truncate && isVideo && <>
                  <div className={`absolute z-20 w-full h-full ${useOverlay && "bg-gray-800/70 mix-blend-multiply"}`} />
                  <div className="isolate absolute z-30 w-full h-full flex justify-center items-center">
                    <Icon className={iconClassName} height="2rem" width="2rem" name="play" />
                  </div>
                </>}
            </div>}></Modal.Trigger> : <button type="button" className={`${containerClasses} thumbs__item bg-transparent p-1 border border-solid border-gray-300 hover:border-gray-500 hover:border-2 hover:p-[3px] active:border-2 active:p-[3px] rounded shadow-none`} data-testid={`${isVideo ? "video" : "photo"}-review-thumbnail`} onClick={setSelectedModalMedia} aria-label={`${isVideo ? "view video" : "view image"} ${productReviewIndex + 1}`}>
          <ThumbnailContent isVideo={isVideo} thumbnailClasses={thumbnailClasses} mediaReview={mediaReview} iconClassName={iconClassName} />
        </button>}
    </>;
};
export default MediaReviewThumbnail;